import React from 'react';
import { PrivateCinema } from '../components/PrivateCinema';
export function CinemaPage() {
  return <main data-id="element-217">
      <PrivateCinema data-id="element-218" />
    </main>;
}